import { render, staticRenderFns } from "./Variation.vue?vue&type=template&id=43b53aaf"
import script from "./Variation.vue?vue&type=script&lang=js"
export * from "./Variation.vue?vue&type=script&lang=js"
import style0 from "./Variation.vue?vue&type=style&index=0&id=43b53aaf&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports